<template>
  <v-app id="aunfcms-app" class="sv-app">
    <sidebar ref="refsidebar" :title="siteName" />
    <toolbar @showSidebar="onShowSidebarRequest" />
    <v-main class="mx-3">
      <router-view :key="$route.path" />
    </v-main>
    <confirm-dialog ref="confirm" />
  </v-app>
</template>

<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import Toolbar from "@/components/Toolbar/Toolbar.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import NotificationMixin from "@/mixins/NotificationMixin.js";

export default {
  components: {
    Sidebar,
    Toolbar,
    ConfirmDialog
  },
  mixins: [NotificationMixin],
  computed: {
    siteName() {
      return this.$store.getters.getSiteName;
    }
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open;
  },
  methods: {
    onShowSidebarRequest() {
      const sidebarObject = this.$refs.refsidebar;
      if (sidebarObject == undefined) return true;
      if (sidebarObject.refCallSidebar == undefined) return true;
      sidebarObject.refCallSidebar();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../styles/branding.scss";

.sv-app {
  background: $brand-window-background;
}
</style>
